module.exports = __webpack_public_path__ + "static/media/Næring.dff784bf.m4a";